<template>
  <div class="vc-tab">
    <VoiceToneSection
      :voice-call="voiceCall"
      :max-my-voices="maxMyVoices"
      :max-speech-params="maxParams"
      @open-my-voices="openMyVoicesManage"
    />

    <MyVoicesModal
      v-model="myVoicesModalVisible"
      :initial-tab="myVoicesInitialTab"
      :voice-call="voiceCall"
      :max-my-voices="maxMyVoices"
      @saved="handleVoiceSaved"
      @deleted="handleVoiceDeleted"
    />
  </div>
</template>

<script>
import VoiceToneSection from './VoiceToneSection.vue'
import MyVoicesModal from './MyVoicesModal.vue'

export default {
  name: 'LlmVoiceCallTab',
  components: { VoiceToneSection, MyVoicesModal },
  props: {
    voiceCall: {
      type: Object,
      required: true,
    },
    customerInfoParams: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      maxMyVoices: 5,
      maxParams: 15,
      myVoicesModalVisible: false,
      myVoicesInitialTab: 'add',
    }
  },
  methods: {
    openMyVoicesManage() {
      this.myVoicesInitialTab = 'add'
      this.myVoicesModalVisible = true
    },
    handleVoiceSaved() {
      this.$emit('clone-voice-saved')
    },
    handleVoiceDeleted() {
      this.$emit('clone-voice-saved')
    },
  },
}
</script>

<style lang="scss" scoped>
.vc-tab {
  width: 100%;
  max-width: 100%;
}
</style>
